<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-file-text text-primary mr-2"></i>
                    Gestión de Documentos
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Emails predefinidos
                    <export-actions :rows="getEmailsFilteredData()"></export-actions>
                </b-row>
                <v-client-table
                    ref="emailsTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="columns"
                    :data="emails"
                    :options="options"
                    :theme="theme" @filter="onFilter">

                    <template slot="uuid" slot-scope="props">
                        <router-link :to="{ name: 'editDocuments', params: { uuid: props.row.uuid }, query:{typeOfTemplate: 'email'} }">
                            <i class="fa fa-pencil"></i>
                        </router-link>
                    </template>

                </v-client-table>
            </b-card>
        </b-row>

        <b-row class="py-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Documentos predefinidos
                    <export-actions :rows="getDocumentFilteredData()"></export-actions>
                </b-row>
                <v-client-table
                    ref="documentsTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="columns"
                    :data="documents"
                    :options="options"
                    :theme="theme">

                    <template slot="uuid" slot-scope="props">
                        <router-link :to="{ name: 'editDocuments', params: { uuid: props.row.uuid }, query:{typeOfTemplate: 'doc'} }">
                            <i class="fa fa-pencil"></i>
                        </router-link>
                    </template>

                </v-client-table>
            </b-card>
        </b-row>

        <b-row class="py-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Documentos para adjuntar a emails
                    <span
                        class="btn p-0"
                        @click="showCreateAttachmentForm">
                        <i class="fa fa-plus"></i>
                    </span>
                </b-row>
                <v-client-table
                    ref="documentsTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="columns"
                    :data="attachments"
                    :options="optionsAttachments"
                    :theme="theme">

                    <template slot="uuid" slot-scope="props">
                        <a href="javascript:void(0)" @click="deleteOtherAttachment(props.row.uuid)"><i class="fa fa-trash"></i></a>
                    </template>

                </v-client-table>
            </b-card>

            <b-modal
                ref="addAttachmentModal"
                hide-footer
                size="lg"
                title="Subir Documento"
                centered>
                <b-form @submit.prevent="addAttachment" enctype="multipart/form-data">
                    <b-row>
                        <b-col offset-lg="1" lg="10">
                            <b-form-group
                                label="<strong>Documento</strong>"
                                label-for="attachment"
                                :horizontal="true"
                                class="w-100 mt-2 mb-0 text-left">
                                <b-form-file
                                    id="attachment"
                                    v-model="attachment"
                                    ref="otherAttachment"
                                    placeholder="Seleccione documento...">
                                </b-form-file>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col offset-lg="1" lg="10">
                            <b-form-group
                                label="<strong>Descripción</strong>"
                                label-for="attachment_description"
                                :horizontal="true"
                                class="w-100 mt-2 mb-0 text-left">
                                <b-form-input id="attachment_description" v-model="attachmentDescription"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="border-top mt-4 pt-3 px-3 flex-row-reverse">
                        <button
                            type="submit"
                            class="btn btn-brand btn-primary col-auto btn-lg float-right"
                            sm="12"
                            :disabled="!attachment">
                            Guardar
                        </button>
                    </b-row>
                </b-form>
            </b-modal>
        </b-row>

    </div>
</template>

<script>

    import VueNotifications from 'vue-notifications';
    import Vue from 'vue';
    import {ClientTable, Event} from 'vue-tables-2';
    import form from '@/helpers/form';
    import {request} from '@/helpers/services';
    import {createOtherAttachment, deleteOtherAttachment} from '@/api/attachment-api';
    import ExportActions from '@/components/ExportActions';

    Vue.use(ClientTable)

    export default {
        name: 'listDocuments',
        components: {
            ClientTable,
            Event,
            ExportActions
        },
        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.options.texts = form.tableLabels();
            this.getAll();
        },
        data: function () {
            return {
                topmenu: [
                    {name: 'Inicio', path: '/admin/dashboard', brand: 'fa fa-home'},
                ],
                action: null,
                documents: [],
                emails: [],
                attachments: [],
                attachment: null,
                attachmentDescription: null,
                document: {
                    name: "",
                    description: "",
                    html: "",
                    uuid: 0,
                    active: false,
                },
                show: false,
                columns: ['uuid', 'name', 'description'],
                options: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        name: 'Nombre',
                        description: 'Descripción',
                        html: 'HTML',
                    },
                    columnsClasses: {uuid: "fit"},
                    sortable: ['name', 'description'],
                    filterable: ['name', 'description'],
                    sortIcon: {base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort'},
                    texts: null,
                    pagination: {
                        chunk: 5,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                useVuex: false,
                theme: 'bootstrap4',
                template: 'default',
            }
        },
        computed: {
            optionsAttachments() {
                let optionsAttachments = this.options;
                if (optionsAttachments.texts) {
                    optionsAttachments.texts['noResults'] = 'Sin documentos';
                }
                return optionsAttachments;
            }
        },
        methods: {
            showCreateAttachmentForm() {
                this.$refs.addAttachmentModal.show();
            },
            resetAttachmentForm() {
                this.attachment = null;
                this.$refs['otherAttachment'].reset();
                this.attachmentDescription = null;
            },
            async addAttachment() {
                this.$_loadingMixin_showLoading();
                await createOtherAttachment(this.attachment, this.attachmentDescription)
                    .then(() => {
                        this.$_notificationMixin_success('Operación completada', 'Se ha subido el documento');
                        this.resetAttachmentForm();
                        this.$refs.addAttachmentModal.hide();
                        this.getOtherAttachments();
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Error en la operación', 'No se ha subido el documento');
                    });
                this.$_loadingMixin_hideLoading();
            },
            async deleteOtherAttachment(attachmentId) {
                this.$_loadingMixin_showLoading();
                await deleteOtherAttachment(attachmentId)
                    .then(async () => {
                        this.$_loadingMixin_hideLoading();
                        await this.getOtherAttachments();
                        this.$_notificationMixin_success('Operación completada', 'Se ha eliminado el documento');
                    })
                    .catch(() => {
                        this.$_loadingMixin_hideLoading();
                        this.$_notificationMixin_error('Error en la operación', 'No se ha eliminado el documento');
                    });
                this.$_loadingMixin_hideLoading();
            },
            async getOtherAttachments() {
                try {
                    this.$_loadingMixin_showLoading();
                    this.attachments = await request('other-attachments', 'get', 200);
                    this.$_loadingMixin_hideLoading();
                } catch (error) {
                    this.showGetErrorMsg();
                    console.log(error);
                }
            },
            async getAll() {
                try {
                    this.$_loadingMixin_showLoading();
                    this.documents = await request('documents', 'get', 200);
                    this.$_loadingMixin_hideLoading();
                } catch (error) {
                    this.showGetErrorMsg();
                    console.log(error);
                }
                try {
                    this.$_loadingMixin_showLoading();
                    this.emails = await request('emails', 'get', 200);
                  let searchValue = this.$store.getters.getTextFilter;
                  if (searchValue === null || searchValue === '') {
                    //console.log(this.headquarters)
                  }  else {
                    document.querySelector('.VueTables__search__input').value  = this.$store.getters.getTextFilter;
                    let filteredLists = []
                    this.emails.map(function (e) {
                      if (e.name.includes(searchValue) || e.description.includes(searchValue)) {
                        filteredLists.push(e)
                      }
                    });
                    this.emails = filteredLists;
                  }
                    this.$_loadingMixin_hideLoading();
                } catch (error) {
                    this.showGetErrorMsg();
                    console.log(error);
                }
                await this.getOtherAttachments();
            },
            getEmailsFilteredData() {
                if (this.$refs.emailsTable) {
                    return this.$refs.emailsTable.allFilteredData.map(email => ({
                        'Nombre': email.name,
                        'Descripción': email.description
                    }));
                } else {
                    return [];
                }
            },
            getDocumentFilteredData() {
                if (this.$refs.documentsTable) {
                    return this.$refs.documentsTable.allFilteredData.map(document => ({
                        'Nombre': document.name,
                        'Descripción': document.description
                    }));
                } else {
                    return [];
                }
            },
            onFilter () {
              let _self = this;
              if (document.querySelector('.VueTables__search__input').value === '') {
                _self.$store.commit('SET_USER_TEXT_FILTER', document.querySelector('.VueTables__search__input').value)
                _self.getAll();
              } else {
                _self.$store.commit('SET_USER_TEXT_FILTER', document.querySelector('.VueTables__search__input').value)
              }
            }
        },
        notifications: {
            showSuccessMsg: {
                type: VueNotifications.types.success,
                title: 'Operación Completada',
                message: 'Código guardado con éxito'
            },
            showErrorMsg: {
                type: VueNotifications.types.error,
                title: 'Acceso denegado',
                message: 'Algo salió mal'
            },
            showGetErrorMsg: {
                type: VueNotifications.types.error,
                title: 'Error inesperado',
                message: 'Problema al recuperar el listado'
            }
        },
    }
</script>
